import * as React from 'react';
import { History } from 'history';
import Model from './address-model';
import BasePicklistCard from '../base/base-picklistcard.component';
import AppService from '../../services/app.service';

interface IProps {
  history: History;
  caption?: string;
  nodataCaption ?: string;
  currentId?: number;
  parentType?: string;
  parentId?: number;
  cardCount?: number;
  cardIconOnly?: boolean
  autoLoad?: boolean;
  onLoad?: (data: any) => void;
}

interface IState {
  datarow: Model;
  currentId: number;
}

export default class AddressPicklistCard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { 
      datarow: Model.defaultValue(),
      currentId : this.props.currentId || 0,
    }
  }

  private isMobile: boolean = AppService.isMobile();
  
  private onLoad = (data: any) => {
    this.props.onLoad?.(data);
  }

  public render(): React.ReactNode {
    return (
      <BasePicklistCard history={this.props.history} endPointFilter={Model.endPointFilterList(this.props.parentType, this.props.parentId)} model={Model} currentId={this.state.currentId} caption={this.props.caption} header={this.props.cardIconOnly && Model.columnPicklistCardType} nodataCaption ={this.props.nodataCaption } onLoad={this.onLoad} pageSize={this.isMobile? 6: 10} cardCount={this.props.cardCount || 2} cardSpacing={0.5} cardBoxShadow={1} cardPadding={1} cardAlign='left' cardIconOnly={this.props.cardIconOnly} swipe={this.isMobile && !this.props.cardIconOnly? 'vertical' : 'horizontal'} autoUnselect autoLoad={this.isMobile || this.props.autoLoad} disableBackButton disableCard/>
    );
  }
}
